
import ConfirmPassword from "../components/common/ConfirmPassword";
import ForgotPassword from "../components/common/ForgotPassword";
import SignUp from "../components/common/SignUp";
import SocialAuthCallback from "../components/common/SocialAuthCallback";
import SuccessMsgPage from "../components/common/SuccessMsgPage";
import Expense from "../components/Pages/AppPAges/Expense/expense";
import Login from "../components/common/Login";
import Purchase from "../components/Pages/AppPAges/Purchase/purchase";
import GeneralLedgerATM from "../components/Pages/AppPAges/GeneralLedger/GeneralLedgerATM";
import GeneralLedgerBank from "../components/Pages/AppPAges/GeneralLedger/GeneralLedgerBank";
import GeneralLedgerOwnerDistribution from "../components/Pages/AppPAges/GeneralLedger/GeneralLedgerOwnerDistribution";
import GeneralLedgerOtherIncome from "../components/Pages/AppPAges/GeneralLedger/GeneralLedgerOtherIncome";
import GeneralLedgerSalesTax from "../components/Pages/AppPAges/GeneralLedger/GeneralLedgerSalesTax";
import GeneralLedgerBankLedger from "../components/Pages/AppPAges/GeneralLedger/GeneralLedgerBankLedger";
import OwnersLedger from "../components/Pages/AppPAges/GeneralLedger/OwnersLedger";
import ManageSettings from "../components/Pages/AppPAges/ManageSettings/ManageSettings";
import StoreInformation from "../components/Pages/AppPAges/ManageSettings/StoreInformation";
import MyProfile from "../components/Pages/AppPAges/ManageSettings/MyProfile";
import ManageUsers from "../components/Pages/AppPAges/ManageSettings/ManageUsers";
import ManageDepartments from "../components/Pages/AppPAges/ManageSettings/ManageDepartments";
import ManageVendor from "../components/Pages/AppPAges/ManageSettings/ManageVendor";
import ManageExpenseType from "../components/Pages/AppPAges/ManageSettings/ManageExpenseType";
import OtherIncomeType from "../components/Pages/AppPAges/ManageSettings/OtherIncomeType";
import PayInvoice from "../components/Pages/AppPAges/Dashboard/Invoice/PayInvoice";
import BankDeposit from "../components/Pages/AppPAges/Dashboard/Invoice/BankDeposit";
import AtmDeposit from "../components/Pages/AppPAges/Dashboard/Invoice/AtmDeposit";
import Accounting from "../components/Pages/AppPAges/Account/Accounting";
import Payment from "../components/Pages/AppPAges/Payments/Payment";
// import Reports from "../components/Pages/AppPAges/Reports/Reports";
import AddInvoice from "../components/Pages/AppPAges/Dashboard/Invoice/AddInvoice";
import ReportDateSelection from "../components/Pages/AppPAges/Reports/ReportDateSelection";
import AuditTrail from "../components/Pages/AppPAges/Auditrail/AuditTrail";
import LotteryOperations from "../components/Pages/AppPAges/Lottery/LotteryOperations";
import WebCamBarcodeScanner from "../components/common/WebCamBarcodeScanner";
import GasInvoice from "../components/Pages/AppPAges/Gas/GasInvoice";
import HouseCharges from "../components/Pages/AppPAges/Gas/HouseCharges";
import GasTaxSettings from "../components/Pages/AppPAges/Gas/GasTaxSettings";
import GasSettings from "../components/Pages/AppPAges/Gas/GasSettings";
import Payroll from "../components/Pages/AppPAges/Payroll/Payroll";
import GeneralLedgerCashLedger from "../components/Pages/AppPAges/GeneralLedger/GeneralLedgerCashLedger";
import MainDashboard from "../components/Pages/AppPAges/Dashboard/MainDashboard";
import BusinessOverview from "../components/Pages/AppPAges/OwnerOverview/BusinessOverview";
import Product from "../components/Pages/AppPAges/InventoryManagement/Product/Product";
import StockTransfer from "../components/Pages/AppPAges/InventoryManagement/StockTransfer/StockTransfer";
import Inventory from "../components/Pages/AppPAges/InventoryManagement/Inventory/Inventory";
import salesInvoice from "../components/Pages/AppPAges/Dashboard/Invoice/SalesInvoice";
import ManageStockView from "../components/Pages/AppPAges/InventoryManagement/ManageStock/ManageStockView";
import QuickInvoice from "../components/Pages/AppPAges/Dashboard/Invoice/QuickInvoice";
import PosQuickInvoice from "../components/Pages/AppPAges/Dashboard/Invoice/PosQuickInvoice";
import ChequeDashboard from "../components/Pages/ChequeApp/ChequeDashboard";
import PayrollDashboard from "../components/Pages/Payroll/Dashboard/PayrollDashboard";
// import Timecard from "../components/Pages/Timecard/Dashboard/Dashboard";
import ChequeForm from "../components/Pages/ChequeApp/PrintCheque/ChequeForm";
import ChequePreview from "../components/Pages/ChequeApp/PrintCheque/ChequePreview";
import ChequeHistory from "../components/Pages/ChequeApp/ChequeHistory/ChequeHistory";
import SalesReport from "../components/Pages/AppPAges/InventoryManagement/SalesReport/SalesReport";
import EmployeeEnrollmentView from "../components/Pages/Timecard/EmployeeEnrollment/EmployeeEnrollmentView";
import EmployeeLogView from "../components/Pages/Timecard/EmployeeLog/EmployeeLogView";
import BiometricPayroll from "../components/Pages/Timecard/BiometricPayroll/BiometricPayroll";
import InventoryDashboard from "../components/Pages/Inventory/Dashboard/Dashboard";
import LotteryDashboard from "../components/Pages/Lottery/DashBoard/Dashboard";
import GasDashboard from "../components/Pages/Gas/Dashboard/Dashboard";
import RetailInvoice from "../components/Pages/AppPAges/Sales/RetailInvoice";
import WholeSaleInvoice from "../components/Pages/AppPAges/Sales/WholeSaleInvoice";
import PointOfSale from "../components/Pages/AppPAges/Sales/PointOfSale";
import InvoiceHistory from "../components/Pages/AppPAges/Sales/SalesHistory/POSInvoiceHistory";
import ExpenseInvoice from "../components/Pages/AppPAges/Expense/expenseInvoice";
import PurchaseInvoice from "../components/Pages/AppPAges/Purchase/purchaseInvoice";
import PayInvoices from "../components/Pages/AppPAges/Purchase/Pay_Invoice";
import AddAtmDespoite from "../components/Pages/AppPAges/Deposite/AddAtmDespoite";
import AddBankDeposite from "../components/Pages/AppPAges/Deposite/AddBankDeposite";
import Statistics from "../components/Pages/AppPAges/Dashboardui/Dashboard";
import AutoLogin from "../components/common/AutoLogin";
import Configuration from "../components/Pages/AppPAges/ManageSettings/Configuration";
import AdditionalInfornation from "../components/common/AdditionalInfornation";
// import SubscriptionSelectModalPopup from "../components/Pages/AppPAges/ManageSettings/SubscriptionSelectModalPopup";
import SalesInvoiceHistory from "../components/Pages/AppPAges/Sales/SalesHistory/SalesInvoiceHistory";
import RetailInvoiceHistory from "../components/Pages/AppPAges/Sales/SalesHistory/RetailInvoiceHistory";
import EcomInvoiceHistory from "../components/Pages/AppPAges/Sales/SalesHistory/EcomInvoiceHistory";
import PosSettings from "../components/Pages/Pos/PosSettings";
import PosData from "../components/Pages/Pos/PosData";
import NotFound from "../components/common/NotFound";
import Transaction from "../components/Pages/Pos/Transaction";
import ReportComponent from "../components/Pages/AppPAges/ReportUi/ReportComponent";
import SubscriptionComponent from "../components/common/WithUi/SubscriptionComponent";
import PaymentComponent from "../components/common/WithUi/PaymentComponent";
import SubscriptionInvoice from "../components/Pages/AppPAges/SubscriptionUI/SubscriptionInvoice";
import Home from "../components/Pages/AppPAges/Dashboard/Home";
import SubscriptionPage from "../components/Pages/AppPAges/SubscriptionUI/SubscriptionPage";
import PaymentPage from "../components/Pages/AppPAges/SubscriptionUI/PaymentPage";
// import SubscriptionModal from "../components/Pages/AppPAges/SubscriptionUI/SubscriptionModal";
import SubscriptionSuccessModal from "../components/common/WithUi/SubscriptionSuccessModal";
import ChangePasswordLayout from "../components/common/ChangePasswordLayout";
import GetReport from "../components/Pages/AppPAges/Lottery/GetReport";
import DailyLottery from "../components/Pages/AppPAges/Lottery/DailyLottery";
import Maindash from "../components/Pages/AppPAges/DashUi/Maindash";
import TransactionData from '../components/Pages/AppPAges/DashUi/TransactionData'
import BiometricCheckView from "../components/Pages/Timecard/BiometricPayroll/BiometricCheckView";
import BusinessReport from "../components/Pages/AppPAges/Reports/BusinessReport";

import LegalDashboard from '../components/Pages/Legal/Dashboard'
import Templates from '../components/Pages/Legal/Templates'
import Policies from '../components/Pages/Legal/Policies'
import DocumentSigning from '../components/Pages/Legal/DocumentSigning/DocumentSigning'
import AuditLogs from '../components/Pages/Legal/AuditLogs'
import SignedDocuments from '../components/Pages/Legal/SignedDocuments'
// import TemplateEditor from '../components/Pages/Legal/TemplateEditor'


import AssetManagementDashboard from "../components/Pages/AssetManagement/Dashboard/AssetManagementDashboard";
import AssetsInventory from "../components/Pages/AssetManagement/AssetsInventory/AssetsInventory";
// import RegisterAssets from "../components/Pages/AssetManagement/RegisterAssets/RegisterAssets";
import AllocateAssets from "../components/Pages/AssetManagement/AllocateAssets/AllocateAssets";
import AssetsRequest from "../components/Pages/AssetManagement/AssetsRequest/AssetsRequest";
import AssetsCategory from "../components/Pages/AssetManagement/AssetCategory/AssetsCategory";
import AssetRequestList from "../components/Pages/AssetManagement/AssetRequestList/AssetRequestList";
import Documents from "../components/Pages/Legal/Documents";
import DocumentPreview from "../components/Pages/Legal/DocumentPreview";
import AssetMaintenance from "../components/Pages/AssetManagement/AssetMaintenance/AssetMaintenance";
import MaintenanceCost from "../components/Pages/AssetManagement/MaintenanceCost/MaintenanceCost";
import RFQManagement from "../components/Pages/AssetManagement/RFQ/RFQManagement";
import QuotationManagement from "../components/Pages/AssetManagement/Quotation/QuotationManagement";
import PurchaseOrderManagement from "../components/Pages/AssetManagement/PurchaseOrder/PurchaseOrderManagement";
import AssetProcurementDashboard from "../components/Pages/AssetManagement/Dashboard/AssetProcurementDashboard";
import InventoryRFQ from "../components/Pages/AppPAges/InventoryManagement/StockProcurement/InventoryRFQ";
import InventoryQuotation from "../components/Pages/AppPAges/InventoryManagement/StockProcurement/InventoryQuotation";
import InventoryPO from "../components/Pages/AppPAges/InventoryManagement/StockProcurement/InventoryPO";
import TimeCardDashboard from "../components/Pages/Timecard/Dashboard/TimeCardDashboard"
import AttendanceRegister from "../components/Pages/Timecard/AttendanceRegister"
//E-com imports
import EcommerceDashboard from "../components/Pages/E-com/Dashboard/EcommerceDashboard";
// import OrderList from "../components/Pages/E-com/Orders/OrderList";
// import ProductList from "../components/Pages/E-com/Products/ProductList";
import AdminDashboard from "../components/Pages/E-com/Controller/AdminDashboard";
import ContentManagement from "../components/Pages/E-com/Controller/ContentManagement";
import MyWebsites from "../components/Pages/E-com/MyWebsites/MyWebsites";
import OrderManagement from "../components/Pages/E-com/Controller/OrderManagement";
import VisitorAnalytics from "../components/Pages/E-com/Analytics/VisitorAnalytics";
import CustomerInsights from "../components/Pages/AppPAges/CustomerInsights/CustomerInsights";
import StaffSalesActivity from "../components/Pages/AppPAges/StaffSalesActivity/StaffSalesActivity";
import ProductCategory from "../components/Pages/AppPAges/InventoryManagement/ProductCategory/ProductCategory";
import MonitorManage from "../components/Pages/Monitering/MonitorManage";
import AlertRule from "../components/Pages/Monitering/AlertRule";
import CameraStream from "../components/Pages/Monitering/CameraStream";
import EventData from "../components/Pages/Monitering/EventData";
import CameraMedia from "../components/Pages/Monitering/CameraMedia";
import MonitorDashboard from "../components/Pages/Monitering/MonitorDashboard";
import MonitorAudit from "../components/Pages/Monitering/MonitorAudit";


const routes = [
  {
    path: "/statistics",
    component: Statistics,
    auth: true,
  },
  //  sales routes
  {
    path: "/retail-Invoice",
    component: QuickInvoice,
    auth: true,
    permissions: "PERM_RETAILS_INVOICE"
  },
  {
    path: "/quick-Invoice",
    component: PosQuickInvoice,
    auth: true,
    permissions: "PERM_QUICK_INVOICE"
  },
  {
    path: "/sales-Invoice",
    component: salesInvoice,
    auth: true,
    permissions: "PERM_WHOLESALE_INVOICE"
  },
  {
    path: "/Report",
    component: ReportComponent,
    auth: true,
    permissions: "PERM_BUSINESS_REPORT"
  },
  {
    path: "/business-report",
    component: BusinessReport,
    auth: true,
    permissions: "PERM_BUSINESS_REPORT"
  },
  {
    path: "/invoice-pos-history",
    component: InvoiceHistory,
    auth: "true",
    permissions: "PERM_QUICK_HISTORY"
  },
  {
    path: "/invoice-sales-history",
    component: SalesInvoiceHistory,
    auth: "true",
    permissions: "PERM_WHOLESALE_HISTORY"
  },
  {
    path: "/invoice-retail-history",
    component: RetailInvoiceHistory,
    auth: "true",
    permissions: "PERM_RETAIL_HISTORY"
  },
  {
    path: "/invoice-ecom-history",
    component: EcomInvoiceHistory,
    auth: "true",
    permissions: "PERM_RETAIL_HISTORY"
  },


  {
    path: "/owner-dashboard",
    component: MainDashboard,
    auth: true,
  },

  {
    path: "/business-overview",
    component: BusinessOverview,
    auth: true,
  },

  {
    path: "/bankDeposit",
    component: BankDeposit,
    auth: true,
  },
  {
    path: "/atmDeposit",
    component: AtmDeposit,
    auth: true,
  },

  {
    path: "/login",
    component: Login,
    auth: false,
  },
  {
    path: "/create-user",
    component: SignUp,
    auth: false,
  },
  {
    path: "/social-auth/callback",
    component: SocialAuthCallback,
    auth: false,
  },
  {
    path: "/forgot-password",
    component: ForgotPassword,
    auth: false,
  },
  {
    path: "/additional-info",
    component: AdditionalInfornation,
    auth: false,
  },

  {
    path: "/auth/pass-reset/:temp_token",
    component: ConfirmPassword,
    auth: false,
  },
  {
    path: "/reset-password/:temp_token",
    component: ConfirmPassword,
    auth: false,
  },
  {
    path: "/success-msg",
    component: SuccessMsgPage,
    auth: false,
  },
  {
    path: "/change-password",
    component: ChangePasswordLayout,
    auth: true,
  },
  // expense and purchase routes
  {
    path: "/expense",
    component: Expense,
    auth: true,
    permissions: "PERM_SPENDS_EXPENSE"

  },
  {
    path: "/purchase",
    component: Purchase,
    auth: true,
    permissions: "PERM_SPENDS_PURCHASE"
  },
  {
    path: "/expense-invoice",
    component: ExpenseInvoice,
    auth: "true",
    permissions: 'PERM_SPENDS_EX-INVOICE'
  },
  {
    path: "/purchase-invoice",
    component: PurchaseInvoice,
    auth: "true",
    permissions: 'PERM_SPENDS_PUR-INVOICE'
  },
  {
    path: "/pay-invoice",
    component: PayInvoices,
    auth: "true",
    permissions: 'PERM_PAY_INVOICE'
  },


  {
    path: "/manage-configuration",
    component: Configuration,
    auth: true,
    permissions: ["PERM_CHEQUE_MANAGE_CONFIGURATION", "PERM_GL_MANAGE_CONFIGURATION", "PERM_PAYROLL_MANAGE_CONFIGURATION",
      "PERM_SALE_MANAGE_CONFIGURATION", "PERM_GAS_MANAGE_CONFIGURATION", "PERM_SPENDS_MANAGE_CONFIGURATION",
      "PERM_INVENTORY_MANAGE_CONFIGURATION", "PERM_LOTTERY_MANAGE_CONFIGURATION", "PERM_POS_MANAGE_CONFIGURATION", "PERM_TIMECARD_MANAGE_CONFIGURATION", "PERM_LEGAL_MANAGE_CONFIGURATION"]
  },
  {
    path: "/store-information",
    component: StoreInformation,
    auth: true,
    // permissions: ["PERM_CHEQUE_STOREINFORMATION", "PERM_GL_STOREINFORMATION" , 
    //   "PERM_SALE_STOREINFORMATION" , "PERM_INVENTORY_STOREINFORMATION" ,
    //    "PERM_LOTTERY_STOREINFORMATION", "PERM_GAS_STOREINFORMATION","PERM_TIMECARD_STOREINFORMATION",
    //   "PERM_POS_STOREINFORMATION", "PERM_SPENDS_STOREINFORMATION", "PERM_PAYROLL_STOREINFORMATION"]
  },
  {
    path: "/manage-users",
    component: ManageUsers,
    auth: true,

    // permissions: ["PERM_CHEQUE_MANAGE_USERS", "PERM_GL_MANAGE_USERS" ,"PERM_TIMECARD_MANAGE_USERS",
    //   "PERM_SALE_MANAGE_USERS" , "PERM_INVENTORY_MANAGE_USERS","PERM_SPENDS_MANAGE_USERS",
    //    "PERM_LOTTERY_MANAGE_USERS" , "PERM_GAS_MANAGE_USERS", "PERM_POS_MANAGE_USERS", "PERM_PAYROLL_MANAGE_USERS", "PERM_TIMECARD_MANAGE_USERS"]
  },
  {
    path: "/customer-insights",
    component: CustomerInsights,
    auth: true,
  },
  {
    path: "/staff-sales-activity",
    component: StaffSalesActivity,
    auth: true,
  },
  {
    path: "/manage-settings",
    component: ManageSettings,
    auth: true,
    permissions: ["PERM_GL_MANAGE_SETTINGS", "PERM_LOTTERY_MANAGE_SETTINGS",
      "PERM_SPENDS_MANAGE_SETTINGS", "PERM_PAYROLL_MANAGE_SETTINGS", "PERM_LEGAL_MANAGE_SETTINGS"]
  },
  {
    path: "/manage-vendor",
    component: ManageVendor,
    auth: true,
    permissions: ["PERM_SALE_MANAGE_VENDOR", "PERM_INVENTORY_MANAGE_VENDOR", "PERM_SPENDS_MANAGE_VENDOR"]
  },
  {
    path: "/manage-expense-type",
    component: ManageExpenseType,
    auth: true,
    permissions: ["PERM_SALE_MANAGE_EXPENSE_TYPE",
      "PERM_INVENTORY_MANAGE_EXPENSE_TYPE", "PERM_SPENDS_MANAGE_EXPENSE_TYPE"]

  },
  {
    path: "/manage-departments",
    component: ManageDepartments,
    auth: true,
    permissions: ["PERM_SALE_MANAGE_DEPARTMENTS",
      "PERM_INVENTORY_MANAGE_DEPARTMENTS", "PERM_SPENDS_MANAGE_DEPARTMENTS"]
  },
  {
    path: "/accounting",
    component: Accounting,
    auth: true,
  },
  {
    path: "/reportDateSelection",
    component: ReportDateSelection,
    auth: true,
  },
  // {
  //   path: "/reports",
  //   component: Reports,
  //   auth: true,

  // },


  {
    path: "/auditrail",
    component: AuditTrail,
    auth: true,
  },
  {
    path: "/payments",
    component: Payment,
    auth: true,
  },
  // General Ledger Routes
  {
    path: "/addInvoice",
    component: AddInvoice,
    auth: true,
    permissions: "PERM_GENERALLEDGER_ADD_INVOICE"

  },
  {
    path: "/payInvoice",
    component: PayInvoice,
    auth: true,
    permissions: "PERM_GENERALLEDGER_PAY_INVOICE"
  },
  {
    path: "/ATM",
    component: GeneralLedgerATM,
    auth: true,
    permissions: "PERM_GENERALLEDGER_ATM"
  },
  {
    path: "/Bank",
    component: GeneralLedgerBank,
    auth: true,
    permissions: "PERM_GENERALLEDGER_BANK"
  },
  {
    path: "/OwnerDist",
    component: GeneralLedgerOwnerDistribution,
    auth: true,
    permissions: "PERM_GENERALLEDGER_OWNER_DISTRIBUTION"
  },
  {
    path: "/OtherIncome",
    component: GeneralLedgerOtherIncome,
    auth: true,
    permissions: ["PERM_GL_OTHER_INCOMETYPE",]
  },
  {
    path: "/SalesTax",
    component: GeneralLedgerSalesTax,
    auth: true,
    permissions: "PERM_GENERALLEDGER_SALES_TAX"
  },
  {
    path: "/bankLedger",
    component: GeneralLedgerBankLedger,
    auth: true,
    permissions: "PERM_GENERALLEDGER_BANK_LEDGER"
  },
  {
    path: "/cashLedger",
    component: GeneralLedgerCashLedger,
    auth: true,
    permissions: "PERM_GENERALLEDGER_CASH_LEDGER"
  },
  {
    path: "/owners-ledger",
    component: OwnersLedger,
    auth: true,
    permissions: "PERM_GENERALLEDGER_OWNER_DISTRIBUTION"
  },



  {
    path: "/my-profile",
    component: MyProfile,
    auth: true,
  },
  {
    path: "/other-income-type",
    component: OtherIncomeType,
    auth: true,
  },

  // Lottery Routes
  {
    path: "/lottery-operations",
    component: LotteryOperations,
    auth: true,
    permissions: "PERM_LOTTERY"
  },
  {
    path: "/daily-lottery",
    component: DailyLottery,
    auth: true,
    permissions: "PERM_DAILY_LOTTERY"
  },

  // Gas Routes
  {
    path: "/gas-dashboard",
    component: GasDashboard,
    auth: "true",
    permissions: "PERM_GAS_DASHBOARD"
  },
  {
    path: "/gas-invoice",
    component: GasInvoice,
    auth: true,
    permissions: "PERM_GAS_INVOICE"
  },
  {
    path: "/gas-settings",
    component: GasSettings,
    auth: true,
    permissions: "PERM_GAS_SETTINGS"
  },

  {
    path: "/gas-tax-settings",
    component: GasTaxSettings,
    auth: true,
    permissions: "PERM_GAS_TAX_SETTINGS"
  },
  {
    path: "/house-charges",
    component: HouseCharges,
    auth: true,
  },
  {
    path: "/barcode",
    component: WebCamBarcodeScanner,
    auth: true,
  },
  {
    path: "/report-preview",
    component: GetReport,
    auth: false,
  },

  // Inventory Routes
  {
    path: "/inventory-dashboard",
    component: InventoryDashboard,
    auth: "true",
    permissions: "PERM_INVENTORY_DASHBOARD"

  },
  {
    path: "/product",
    component: Product,
    auth: true,
    permissions: "PERM_PRODUCT"
  },
  {
    path: "/inventory-stock-transfer",
    component: StockTransfer,
    auth: true,
    permissions: "PERM_PRODUCT"
  },
  {
    path: "/inventory",
    component: Inventory,
    auth: true,
    permissions: "PERM_PRODUCT_INVENTORY"
  },
  {
    path: "/stock-history",
    component: ManageStockView,
    auth: true,
    permissions: "PERM_MANAGE_STOCK"
  },

  // Payroll Routes
  {
    path: "/payroll-dashboard",
    component: PayrollDashboard,
    auth: "true",
    permissions: "PERM_PAYROLL_DASHBOARD"
  },
  {
    path: "/employee-payroll",
    component: Payroll,
    auth: true,
    permissions: "PERM_MANUAL_PAYROLL"
  },
  {
    path: "/employee-biometric-payroll",
    component: BiometricPayroll,
    auth: "true",
    permissions: "PERM_BIOMETRIC_PAYROLL"
  },

  // timecard routes
  {
    path: "/timecard-dashboard",
    component: TimeCardDashboard,
    auth: "true",
    permissions: 'PERM_TIMECARD_DASHBOARD'
  },

  {
    path: "/attendance-register",
    component: AttendanceRegister,
    auth: "true",
    permissions: 'PERM_TIMECARD_ATTENDANCE_REGISTER'
  },
  {
    path: "/employee-enrollment",
    component: EmployeeEnrollmentView,
    auth: "true",
    permissions: 'PERM_EMPLOYEE_ENROLLMENT'
  },

  {
    path: "/employee-logs",
    component: EmployeeLogView,
    auth: "true",
    permissions: 'PERM_EMPLOYEE_LOG'
  },

  // Cheque Routes
  {
    path: "/cheque-dashboard",
    component: ChequeDashboard,
    auth: "true",
    permissions: "PERM_CHEQUE_DASHBOARD"
  },
  {
    path: "/cheque-form",
    component: ChequeForm,
    auth: "true",
    permissions: "PERM_CHEQUE_FORM"
  },
  {
    path: "/cheque-preview",
    component: ChequePreview,
    auth: "true",
    permissions: "PERM_CHEQUE_FORM"
  },
  {
    path: "/cheque-history",
    component: ChequeHistory,
    auth: "true",
    permissions: "PERM_CHEQUE_HISTORY"
  },
  {
    path: "/sales-report",
    component: SalesReport,
    auth: "true",
  },
  {
    path: "/lottery-dashboard",
    component: LotteryDashboard,
    auth: "true",
    permissions: "PERM_LOTTERY_DASHBOARD"
  },

  {
    path: "/new-retail-invoice",
    component: RetailInvoice,
    auth: true,
    permissions: "PERM_RETAILS_INVOICE"
  },
  {
    path: "/wholesale-invoice",
    component: WholeSaleInvoice,
    auth: true,
    permissions: "PERM_WHOLESALE_INVOICE"
  },
  {
    path: "/pos-invoice",
    component: PointOfSale,
    auth: true,
    permissions: "PERM_QUICK_INVOICE"
  },


  {
    path: "/atm-invoice",
    component: AddAtmDespoite,
    auth: true,
  },
  {
    path: "/bank-invoice",
    component: AddBankDeposite,
    auth: true,
  },
  {
    path: "/autologin/:refreshToken", // This will capture the token as a parameter
    component: AutoLogin,
    auth: false,
  },
  {
    path: "/autologin/:refreshToken", // This will capture the token as a parameter
    component: AutoLogin,
    auth: false,
  },


  // Point of sale routes
  {
    path: "/pos-settings",
    component: PosSettings,
    auth: true,
    permissions: 'PERM_PRODUCT_SETTING'
  },
  {
    path: "/pos-main",
    component: PosData,
    auth: true,
  },
  {
    path: "/pos-dashboard",
    component: PosData,
    auth: true,
    permissions: 'PERM_POS_DASHBOARD'
  },
  {
    path: "/pos-invoices",
    component: Transaction,
    auth: true,
    permissions: 'PERM_POS_TRANSACTION'
  },

  {
    path: "/nopageofound",
    component: NotFound,
    auth: false,
  },

  {
    path: "/subscription-page",
    component: SubscriptionComponent,
    auth: false,
  },
  {
    path: "/payment-page",
    component: PaymentComponent,
    auth: false,
  },

  {
    path: "/subscription-modal",
    component: SubscriptionSuccessModal,
    auth: false,
  },

  // in app component for subscription
  {
    path: "/subscriptionPage",
    component: SubscriptionPage,
    auth: true,
  },
  {
    path: "/paymentPage",
    component: PaymentPage,
    auth: true,
  },
  {
    path: "/subscriptionInvoice",
    component: SubscriptionInvoice,
    auth: true
  },
  {
    path: "/",
    component: Home,
    auth: true
  },
  {
    path: "/owner-dashobaord",
    component: Maindash,
    auth: true
  },
  {
    path: "/transaction",
    component: TransactionData,
    auth: true
  },
  {
    path: "/biometric-logs",
    component: BiometricCheckView,
    auth: true
  },

  // Legal Management System Routes
  {
    path: "/legal-dashboard",
    component: LegalDashboard,
    auth: true,
    permissions: "PERM_LEGAL_DASHBOARD"
  },
  {
    path: "/legal-templates",
    component: Templates,
    auth: true,
    permissions: "PERM_LEGAL_TEMPLATES"
  },
  {
    path: "/legal-policies",
    component: Policies,
    auth: true,
    permissions: "PERM_LEGAL_POLICIES"
  },
  {
    path: "/legal-document-signing",
    component: DocumentSigning,
    auth: true,
    permissions: "PERM_LEGAL_DOCUMENT_SIGNING"
  },
  {
    path: "/signed-documents",
    component: SignedDocuments,
    auth: true,
    permissions: "PERM_LEGAL_SIGNED_DOCUMENTS"
  },
  {
    path: "/legal-documents",
    component: Documents,
    auth: true,
    //  restrictedRoles: ["store owner"],
    permissions: "PERM_LEGAL_DOCUMENTS"
  },

  {
    path: "/document-preview/:id",
    component: DocumentPreview,
    auth: false,
    //  restrictedRoles: ["store owner"],
    //  permissions: "PERM_LEGAL_DOCUMENTS"
  },
  {
    path: "/legal-audit-logs",
    component: AuditLogs,
    auth: true,
    permissions: "PERM_LEGAL_AUDIT_LOGS"
  },
  {
    path: "/asset-management-dashboard",
    component: AssetManagementDashboard,
    auth: true,
    permissions: "PERM_ASSET_DASHBOARD"
  },
  {
    path: "/asset-inventory",
    component: AssetsInventory,
    auth: true,
    permissions: "PERM_ASSET_INVENTORY"
  },
  {
    path: "/asset-request",
    component: AssetsRequest,
    auth: true,
    permissions: "PERM_ASSET_REQUEST",
    restrictedRoles: ["store owner"]
  },
  {
    path: "/asset-request-list",
    component: AssetRequestList,
    auth: true,
    permissions: "PERM_ASSET_REQUEST_LIST"
  },
  {
    path: "/asset-allocation",
    component: AllocateAssets,
    auth: true,
    permissions: "PERM_ASSET_ALLOCATION"
  },
  {
    path: "/asset-category",
    component: AssetsCategory,
    auth: true,
    permissions: "PERM_ASSET_CATEGORY"
  },
  {
    path: "/asset-maintenance",
    component: AssetMaintenance,
    auth: true,
    permissions: "PERM_ASSET_MAINTENANCE"
  },
  {
    path: "/asset-maintenance-cost",
    component: MaintenanceCost,
    auth: true,
    permissions: "PERM_ASSET_MAINTENANCE_COST"
  },
  {
    path: "/rfq-management",
    component: RFQManagement,
    auth: true,
    permissions: "PERM_ASSET_RFQ_MANAGEMENT"
  },
  {
    path: "/quotation-management",
    component: QuotationManagement,
    auth: true,
    permissions: "PERM_ASSET_QUOTATION_MANAGEMENT"
  },
  {
    path: "/purchase-order-management",
    component: PurchaseOrderManagement,
    auth: true,
    permissions: "PERM_ASSET_PURCHASE_ORDER_MANAGEMENT"
  },
  {
    path: "/asset-procurement-dashboard",
    component: AssetProcurementDashboard,
    auth: true,
    permissions: "PERM_ASSET_PROCUREMENT_DASHBOARD"
  },
  {
    path: "/inventory-rfq",
    component: InventoryRFQ,
    auth: true,
    permissions: "PERM_ASSET_PROCUREMENT_DASHBOARD"
  },
  {
    path: "/inventory-quotation-management",
    component: InventoryQuotation,
    auth: true,
    permissions: "PERM_ASSET_PROCUREMENT_DASHBOARD"
  },
  {
    path: "/inventory-po",
    component: InventoryPO,
    auth: true,
    permissions: "PERM_ASSET_PROCUREMENT_DASHBOARD"
  },
  {
    path: "/asset-management-dashboard",
    component: AssetManagementDashboard,
    auth: true,
    permissions: "PERM_ASSET_SETTINGS"
  },
  {
    path: "/asset-inventory",
    component: AssetsInventory,
    auth: true,
    permissions: "PERM_ASSET_SETTINGS"
  },
  {
    path: "/asset-request",
    component: AssetsRequest,
    auth: true,
    permissions: "PERM_ASSET_SETTINGS"
  },
  {
    path: "/asset-allocate",
    component: AllocateAssets,
    auth: true,
    permissions: "PERM_ASSET_SETTINGS"
  },
  //E-com Routes

  {
    path: "/ecommerce/dashboard",
    component: EcommerceDashboard,
    auth: true,
  },

  {
    path: "/ecommerce/my-websites",
    component: MyWebsites,
    auth: true,
  },
  {
    path: "/ecommerce/orders",
    component: OrderManagement,
    auth: true,
  },
  {
    path: "/ecommerce/visitor-analytics",
    component: VisitorAnalytics,
    auth: true,
  },

  {
    path: "/ecommerce/Controller",
    component: AdminDashboard,
    auth: true,
  },

  {
    path: "/ecommerce/content-management",
    component: ContentManagement,
    auth: true,
  },
  {
    path: "/product-category",
    component: ProductCategory,
    permissions: "PERM_PRODUCT_CATEGORY",
    auth: true,
  },
  // monitoring App Routes
  {
    path: "/monitor/dashboard",
    component: MonitorDashboard,
    auth: true,
  },
  {
    path: "/monitor/cameras",
    component: MonitorManage,
    auth: true,
  },
  {
    path: "/monitor/groups",
    component: MonitorManage,
    auth: true,
  },
  {
    path: "/monitor/alert-rules",
    component: AlertRule,
    auth: true,
  },
  {
    path: "/monitor/live-monitor",
    component: CameraStream,
    auth: true,
  },
  {
    path: "/monitor/events",
    component: EventData,
    auth: true,
  },
  {
    path: "/monitor/media",
    component: CameraMedia,
    auth: true,
  },
  {
    path: "/monitor/audit",
    component: MonitorAudit,
    auth: true,
  }
];
export const getRoutes = () => routes;
